import { createReducer, on } from '@ngrx/store';
import {
  loadExtensionAgents,
  loadExtensionAgentsSuccess,
  loadExtensionAgentsFailure,
  deleteExtensionAgent,
  deleteExtensionAgentSuccess,
  deleteExtensionAgentFailure
} from './extension-agentlist.actions';
import { IExtensionAgent } from '../../models/extension-agentlist.model';

export interface ExtensionAgentListState {
  agents: IExtensionAgent[];
  loading: boolean;
  error: string | null;
  count: number;
}

export const initialState: ExtensionAgentListState = {
  agents: [],
  loading: false,
  error: null,
  count: 0
};

export const extensionAgentListReducer = createReducer(
  initialState,
  on(loadExtensionAgents, (state): ExtensionAgentListState => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadExtensionAgentsSuccess, (state, { response }): ExtensionAgentListState => ({
    ...state,
    agents: response.agents,
    count: response.count,
    loading: false
  })),
  on(loadExtensionAgentsFailure, (state, { error }): ExtensionAgentListState => ({
    ...state,
    error: error.message,
    loading: false
  })),
  on(deleteExtensionAgent, (state): ExtensionAgentListState => ({
    ...state,
    loading: true
  })),
  on(deleteExtensionAgentSuccess, (state, { agentId }): ExtensionAgentListState => ({
    ...state,
    agents: state.agents.filter(agent => agent._id !== agentId),
    count: state.count - 1,
    loading: false
  })),
  on(deleteExtensionAgentFailure, (state, { error }): ExtensionAgentListState => ({
    ...state,
    error: error.message,
    loading: false
  }))
);